import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageRacesList,
  PageRace,
} from '../pages/races';

const RouteRaces = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageRacesList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageRace />
      </Route>
    </Switch>
  );
};

export default RouteRaces;
